module.exports = __webpack_public_path__ + "img/logo-icon.56489226.png";